import * as React from "react";
import { Routes, Route } from "react-router-dom";
import Login from "../domain/Auth/components/Login/Login";
import RequireAuth from "../domain/Auth/components/RequiredAuth/RequiredAuth";
import SignUp from "../domain/Auth/components/SignUp/SignUp";
import { Dashboard } from "../domain/Dashboard/Dashboard";
import SideBarWrapper from "../domain/Layouts/components/SideBarWrapper/SideBarWrapper";
import { SettingsPage } from "../domain/Settings/SettingsPage";
import {  FiCode, FiSettings } from "react-icons/fi";
import { BsCollectionPlay, BsFile, BsFolder, BsPlayCircle } from "react-icons/bs";
import { CollectionPage } from "../domain/Collections/CollectionPage/CollectionPage";
import { StoryPage } from "../domain/Collections/Story/StoryPage";
import { StackPage } from "../domain/Stacks/StackPage";
import { WidgetPage } from "../domain/Widget/WidgetPage/WidgetPage";


export const LinkItems = [
  { name: "stories", icon: BsPlayCircle },
  { name: "stacks", icon: BsCollectionPlay },
  { name: "collections", icon: BsFolder },
  { name: "Widget", icon: FiCode },
  { name: "settings", icon: FiSettings },
];



function RoutedView() {
  return (
    <div className="App">
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<SignUp />} />
        <Route path="company" element={<RequireAuth><SideBarWrapper /></RequireAuth>}>
          <Route path="/company/:companyId/settings" element={<SettingsPage />} />
          <Route path="/company/:companyId/dashboard" element={<CollectionPage />} />
          <Route path="/company/:companyId/collections" element={<CollectionPage />} />
          <Route path="/company/:companyId/stories" element={<StoryPage />} />
          <Route path="/company/:companyId/stacks" element={<StackPage />} />
          <Route path="/company/:companyId/widget" element={<WidgetPage />} />
        </Route>
      </Routes>
    </div>
  );
}
export default RoutedView;
